(() => {
  const key = 'nexo:wishlist:v1';
  const limit = 80;
  const normalize = value => Array.isArray(value)
    ? [...new Set(value.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)))].slice(0, limit)
    : [];
  const create = getStorage => {
    let memory = [];
    let persistent = true;
    const read = () => {
      if (!persistent) return [...memory];
      try {
        const raw = getStorage().getItem(key);
        try { memory = normalize(raw ? JSON.parse(raw) : []); }
        catch { memory = []; }
      } catch { persistent = false; }
      return [...memory];
    };
    const write = handles => {
      memory = normalize(handles);
      try { getStorage().setItem(key, JSON.stringify(memory)); }
      catch { persistent = false; }
      return [...memory];
    };
    const toggle = handle => {
      const handles = read();
      if (!normalize([handle]).length) return { handles, saved: false, invalid: true };
      if (handles.includes(handle)) return { handles: write(handles.filter(item => item !== handle)), saved: false };
      if (handles.length >= limit) return { handles, saved: false, full: true };
      return { handles: write([handle, ...handles]), saved: true };
    };
    return { read, toggle, remove: handle => write(read().filter(item => item !== handle)), isPersistent: () => persistent };
  };
  window.NexoWishlistStore = Object.freeze({ key, limit, normalize, create });
})();
